import React from "react"
import { Breadcrumb, BreadcrumbItem, Container, Row, Col } from "reactstrap"
import { graphql, useStaticQuery } from "gatsby"
import { FaPhone, FaEnvelope, FaFax } from "react-icons/fa"
import Img from "gatsby-image"
import Layout from "./../components/layout"
import SEO from "./../components/seo"
import "../style/offices.css"

function Offices() {
  const data = useStaticQuery(graphql`
    query {
      usa: file(relativePath: { eq: "usa.png" }) {
        childImageSharp {
          fluid(maxWidth: 125) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      canada: file(relativePath: { eq: "canada.png" }) {
        childImageSharp {
          fluid(maxWidth: 125) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      australia: file(relativePath: { eq: "australia.png" }) {
        childImageSharp {
          fluid(maxWidth: 125) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Layout>
      <SEO />
      <Breadcrumb className="breadCrumb">
        <BreadcrumbItem>
          <a className="breadCrumbLinks" href="/">
            Home
          </a>
        </BreadcrumbItem>
        <BreadcrumbItem active>Offices</BreadcrumbItem>
      </Breadcrumb>
      <Container>
        <h1>Offices</h1>
        <h2>Worldwide</h2>
        <Row style={{ marginBottom: "1em" }}>
          <Col className="office-cols" sm="6">
            <Img
              className="offices-images canada-image"
              fluid={data.canada.childImageSharp.fluid}
              alt="Canadian Flag"
            />
            <address>
              <b>International Software Products (HEAD OFFICE)</b>
              <br />
              10 Morrow Ave.,
              <br />
              Suite 203 Toronto,
              <br />
              ON M6R 2J1 Canada
              <br />
            </address>
            <p>
              {/* Tel:  */}
              <FaPhone />
              <a href="tel:+1-800-295-7608"> 1-800-295-7608</a>,{" "}
              <a href="+1-416-593-5578"> 1-416-593-5578</a>
              <br />
              {/* Fax:  */}
              <FaFax /> 1-800-295-7609, 1-416-593-5579
              <br />
              {/* E-Mail: */}
              <FaEnvelope />
              <a
                href="mailto:tech.support@intnlsoftwareproducts.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                {" "}
                info@intnlsoftwareproducts.com
              </a>
            </p>
          </Col>
          <Col className="office-cols" sm="6">
            <Img
              className="offices-images usa-image"
              fluid={data.usa.childImageSharp.fluid}
              alt="United States of America Flag"
            />
            <address>
              <b>International Software Products Inc.</b>
              <br />
              7128 Parkside Lane Unit 111
              <br />
              Racine, WI 53406
              <br />
              U.S.A.
              <br />
            </address>
            <p>
              {/* Tel:  */}
              <FaPhone />
              <a href="tel:+1-800-295-7608"> 1-800-295-7608</a>
              <br />
              {/* Fax:  */}
              <FaFax /> 1-800-295-7609
              <br />
              {/* E-mail: */}
              <FaEnvelope />
              <a
                href="mailto:tech.support@intnlsoftwareproducts.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                {" "}
                info@intnlsoftwareproducts.com
              </a>
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs="12">
            <h3>(International Callers)</h3>
          </Col>
        </Row>
        <h2>Australia, New Zealand and S.E. Asia</h2>
        <Row>
          <Col className="office-cols" sm="6">
            <Img
              className="offices-images australia-image"
              fluid={data.australia.childImageSharp.fluid}
              alt="Australian Flag"
            />
            <address>
              <b>AIM Software International Pty. Ltd.</b>
              <br />
              PO Box 1048
              <br />
              Newport Beach, 2106
              <br />
              NSW, Australia
            </address>
            <p>
              {/* Tel:  */}
              <FaPhone />
              <a href="tel:+61-29-973-3289"> 61-29-973-3289</a>
              <br />
              {/* Fax:  */}
              <FaFax /> 61-29-973-3623
              <br />
              {/* E-Mail: */}
              <FaEnvelope />{" "}
              <a href="mailto:jeff.grant@pobox.com">
                AIM Software International
              </a>
            </p>
          </Col>
          <Col className="office-cols" xs="6"></Col>
        </Row>
      </Container>
    </Layout>
  )
}

export default Offices
